import { defineComponent } from 'vue';
import BasePasswordInput from '@/components/Base/Forms/Inputs/BasePasswordInput.vue';
import { mapActions, mapGetters } from 'vuex';
export default defineComponent({
    name: 'checkout-register-password',
    props: {
        customer_email: {
            type: String,
            required: true,
        },
        order_id: {
            type: String,
            required: true,
        },
        bonus_points: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    components: {
        BasePasswordInput,
    },
    data() {
        return {
            show_password: false,
            password: '',
            user_registered: false,
            button_shake: false,
        };
    },
    methods: Object.assign({ showPassword() {
            this.show_password = !this.show_password;
        },
        submitPassword() {
            this.button_shake = false;
            this.registerUserFromBlueOrder({
                orderId: this.order_id,
                password: this.password,
                confirmedPassword: this.password,
            }).catch((error) => {
                console.log('Catch ERROR: ', error);
                this.button_shake = true;
            });
        } }, mapActions('blue', {
        registerUserFromBlueOrder: 'REGISTER_FROM_ORDER',
    })),
    computed: Object.assign({}, mapGetters('account', { isLogin: 'isLogin' })),
});
